import { MobileRender } from '@gaodun.com/mobile-render';
import * as comps from '@gaodun.com/me-design';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import qs from 'query-string';
import { confirmInputTrueName } from './utils';
import { useQuery } from '@tanstack/react-query';
import { getTemplateById } from '../../api/template';
import OrderPayWaiting from '../order/order-pay-waiting';
import CopyRight from '../copy-right';
import QuestionnaireItem from '../questionnaire/questionnaire-item';
import { getSurveyInfo } from '../../service/SurveyService';
import ActivityQa from '../../components/activity/activity-qa';
import LeaveDialog from '../dialog/dialog';
import { defaultLayerUrl } from '../../utils/constant';
import authentication from '../../service/authentication';
import { sensorsTrack } from '../../service/sensors';

interface SchemaRenderProps {
    schemaSource?: any;
    productInfo: any;
    initProductInfo?: () => void;
}
const SchemaRender: React.FC<Props & SchemaRenderProps> = props => {
    const { productInfo, initProductInfo } = props;
    const params = useParams();
    const layerType = productInfo?.activity?.layerType === 'CUSTOM';
    const retainRedirectValue = productInfo?.activity?.ext ? JSON.parse(productInfo.activity.ext).retainRedirectValue : '';

    const [questionList, setQuestionList] = useState<any>([]);
    const [showLeaveDialog, setShowLeaveDialog] = useState<boolean>(false);
    const retainModalHasShow = useRef<boolean>(true);
    const timer = useRef<any>(null);

    const dialogStatusChange = (status: boolean, callback: any) => {
        setShowLeaveDialog(status);
    };

    const templateId = productInfo?.activity?.templateConfigId || productInfo?.activity?.channelDeliveryVersion?.templateConfigId;
    const { data: templateData,  isSuccess } = useQuery([templateId], () => getTemplateById({ id: templateId }), {
        enabled: !!templateId,
    });
    const emptyJson = '{"type":"object","properties":{}}';
    const schemaSource = JSON.parse(templateData?.result?.templateData || emptyJson);

    const historyHandler = () => {
        if (retainModalHasShow.current) {
            timer.current = setTimeout(() => {
                setShowLeaveDialog(true);
                retainModalHasShow.current = false
            }, 0);
        }
    };
    const hasRetainComps = Object.values(schemaSource?.properties).some((item: any) => item?.widget === 'SmRetainModal')
    useEffect(() => {
        if (window.history) {
            if(hasRetainComps) return 
            if (!productInfo?.hasBuy && !productInfo?.layerStatus && isSuccess) {
                window.history.pushState('back', '', '');
                window.addEventListener('popstate', historyHandler);
            }
        } else {
            throw new Error('您的浏览器版本过低，请升级您的浏览器');
        }
        return () => {
            clearTimeout(timer.current);
        };
    }, [hasRetainComps, isSuccess]);

    // 获取表单信息
    const getActivityInfo = async () => {
        let { x_field_1, surveyActivityId } = qs.parse(location.search);
        let activityParams: any = surveyActivityId ? { activityId: surveyActivityId } : { x_field: x_field_1 };
        let activityInfo;
        try {
            activityInfo = await getSurveyInfo(activityParams);
            setQuestionList(activityInfo?.survey?.questionList || []);
        } catch (error) {}
    };

    useEffect(() => {
        let { x_field_1 } = qs.parse(location.search);
        console.log(productInfo,'productInfo')
        const { activity, productSource, products, isTrial } = productInfo
        const product = productSource ||
                    (products && (activity.channelDeliveryGroupId || products.length === 1) ? products[0] : null) ||
                    (isTrial ? products[0] : null)
                    console.log(product,'product')
        sensorsTrack('SCRM_activitydetail__view', {
            scrm_activity_way: activity.activityWay,
            scrm_activity_name: activity.name,
            scrm_activity_id: activity.id,
            scrm_product_name: product ? product.productName : '',
            scrm_plan_name: activity.planName,
            scrm_plan_id: activity.planId,
            scrm_xField: x_field_1 || '',
        });
        getActivityInfo();
        authentication('silence');
    }, []);


   
    const onLoginSuccess = data => {};
    const linkClassDetail = async (orderProduct: any = null) => {
        const { orderToken, courseInfoRedirect, gliveId, lightCourseId } = orderProduct;
        // courseInfoRedirect: 课程跳转设置:1课程详情页,2购买成功页
        if (courseInfoRedirect == 2) {
            props.history.push(`/success/${orderToken}`);
            return;
        }
        // 非直播 && 非轻课
        if (!gliveId && !lightCourseId) {
            props.history.push('/classlist');
            return;
        }
        props.history.push(
            qs.stringifyUrl({
                url: '/classdetail',
                query: { orderToken },
            })
        );
    };

    const handleStudy = ({ productType, hasBuy, orderProduct }) => {
        if (productType == 1 && hasBuy == 1) {
            linkClassDetail(orderProduct);
            return;
        }
        switch (productType) {
            case 1:
                linkClassDetail();
                break;
            case 2:
                window.location.href = 'https://applink.gaodun.com/sw/W';
                break;
            case 3:
            case 4:
                props.history.push('/couponlist');
                break;
            case 5:
                break;
            case 6:
                props.updataBindPhoneVisit(true); //目前可能有问题
                window['observer'].once('loginSuccess', () => {
                    initProductInfo?.();
                });
                break;
            default:
                break;
        }
    };
    const push = url => {
        props.history.push(url);
    };

    const loginFns = {
        onLoginSuccess,
    };

    const buttonFns = {
        handleStudy,
        push,
        confirmInputTrueName,
    };

    const commonFns = {
        initProductInfo,
    };

    const compsParams = {
        params: {
            params,
            search: location.search,
        },
        productInfo: productInfo,
        questionList: questionList,
        form: props.form,
        QuestionnaireItem: QuestionnaireItem,
        ActivityQa: ActivityQa,
    };
    return (
        <>
            {Object.keys(schemaSource.properties).map((item, index) => {
                let compsItem = schemaSource.properties?.[item];
                // tiangong编辑器中数据格式与c端不一致，需要做兼容，将props中的数据提升到最外层
                compsItem = { ...compsItem, ...compsItem.props, ...compsParams, guidWidget: compsItem?.widget };
                const widget = compsItem?.widget;
                const Comp = comps[widget];
                Comp.settings.schema.params = {
                    params,
                    search: location.search,
                    // 这个时候的source代表在h5中，已绑定活动的模版，并非生产环境
                    source: 'production',
                };
                const type = compsItem?.type;
                const schema = { properties: { widget: compsItem }, type: 'object' };
                const customFns = { ...loginFns, ...buttonFns, ...commonFns };
                return <MobileRender schema={schema} widgets={{ [widget]: Comp }} key={type + index} customFns={customFns} />;
            })}
            <OrderPayWaiting />
            {/* <CopyRight rightBottomNone={true} /> */}
            {/* 挽留层 */}
            {showLeaveDialog && !productInfo?.hasBuy ? (
                <LeaveDialog
                    imageSrc={layerType ? productInfo?.activity.layerUrl : defaultLayerUrl}
                    closeBtn={layerType}
                    retainRedirectValue={retainRedirectValue}
                    errorText=""
                    okText="继续浏览"
                    statusChange={dialogStatusChange}
                />
            ) : null}
        </>
    );
};

export default SchemaRender;
